var _defs, _line, _line2, _line3, _line4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack180({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 15,
    x2: 11.95,
    y2: 11.95
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.05,
    y1: 4.05,
    x2: 1,
    y2: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 1,
    x2: 11.95,
    y2: 4.05
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 15,
    x2: 4.05,
    y2: 11.95
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack180);
export default __webpack_public_path__ + "static/media/Symbolpack_1_80.5a32802dcc2350888f542687bac9ce29.svg";
export { ForwardRef as ReactComponent };